import { Help } from '@gympass/tai-chi/icons';
import { createLink } from '@tanstack/react-router';
import { useCallback } from 'react';

import { Button } from 'components/atoms/Button';
import { useEventData } from 'pages/Signup/hooks/useEventData';
import { useEventTracking } from 'providers/EventTrackingProvider';
import { useLocalization } from 'providers/LocalizationProvider';
import { HELP_CENTER_URLS, buildHelpCenterURL } from 'utils/links';

const LinkComponent = createLink(Button);

function HelpLink(props: React.ComponentProps<typeof LinkComponent>) {
  return <LinkComponent preload="intent" {...props} />;
}

export function HelpButton() {
  const { t, language } = useLocalization('header.button.help_center');
  const { recordClick } = useEventTracking();
  const { category, contextData } = useEventData();

  const { faqTab: tab } = HELP_CENTER_URLS[language];

  const helpCenterParams = {
    language,
    path: 'articles',
    tab,
  };

  const url = buildHelpCenterURL(helpCenterParams);

  const onClick = useCallback(() => {
    recordClick({
      category,
      label: 'help_center',
      contextData,
    });
  }, [recordClick, category, contextData]);

  return (
    <HelpLink
      onClick={onClick}
      endIcon={<Help color="inherit" />}
      ariaLabel={t('aria_label')}
      size="small"
      variant="outlined"
      to={url}
      target="_blank"
    >
      {t('label')}
    </HelpLink>
  );
}
